
        import type { DefaultTemplateRootProps, TemplateResult } from 'Components/types';
type SearchBoxRTRootProps = DefaultTemplateRootProps;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function SearchBoxRT(): TemplateResult<SearchBoxRTRootProps> {
    return _createElement('form', { 'onSubmit': this.preventFormSubmission }, _createElement('div', { 'className': 'cm_search-box_form-container' }, [
        [this.searchInput(function () {
                return _createElement('div', { 'className': 'cm_searchInput' }, window.Convermax.config?.searchBoxPlaceholderText || _translate(`search_box_placeholder`));
            }, {
                widgetName: 'undefined',
                items: undefined
            })],
        _createElement('span', {
            'className': 'cm_search-box_clear-container',
            'key': '972'
        }, this.inputNotEmpty ? _createElement('span', {
            'className': 'cm_search-box_clear',
            'onClick': this.clearInput,
            'key': '453'
        }, '\n    ', _translate(`search_box_clear`), '\n  ') : null),
        _createElement('button', {
            'type': 'button',
            'title': 'Search',
            'aria-label': 'search button',
            'className': 'cm_search-box_submit',
            'data-cm-role': 'add-query',
            'key': '974'
        }, [_createElement('svg', {
                'role': 'presentation',
                'strokeWidth': '2',
                'focusable': 'false',
                'width': '22',
                'height': '22',
                'className': 'icon icon-search',
                'viewBox': '0 0 22 22',
                'key': '7210'
            }, _createElement('circle', {
                'cx': '11',
                'cy': '10',
                'r': '7',
                'fill': 'none',
                'stroke': 'currentColor'
            }), _createElement('path', {
                'd': 'm16 15 3 3',
                'stroke': 'currentColor',
                'strokeLinecap': 'round',
                'strokeLinejoin': 'round'
            }))])
    ]), [this.dropdown(function () {
            function repeatSections1(sections, sectionsIndex) {
                return [sections(function () {
                        function repeatItems1(items, itemsIndex) {
                            return [items(function () {
                                    function mergeProps_text(inline, external) {
                                        var res = Object.assign({}, inline, external);
                                        if (inline.hasOwnProperty('style')) {
                                            res.style = _.defaults(res.style, inline.style);
                                        }
                                        if (inline.hasOwnProperty('className') && external.hasOwnProperty('className')) {
                                            res.className = external.className + ' ' + inline.className;
                                        }
                                        return res;
                                    }
                                    function mergeProps_product(inline, external) {
                                        var res = Object.assign({}, inline, external);
                                        if (inline.hasOwnProperty('style')) {
                                            res.style = _.defaults(res.style, inline.style);
                                        }
                                        if (inline.hasOwnProperty('className') && external.hasOwnProperty('className')) {
                                            res.className = external.className + ' ' + inline.className;
                                        }
                                        return res;
                                    }
                                    function onError1_facetValue(e) {
                                        e.target.classList.add('cm_hide');
                                    }
                                    function mergeProps_facetValue(inline, external) {
                                        var res = Object.assign({}, inline, external);
                                        if (inline.hasOwnProperty('style')) {
                                            res.style = _.defaults(res.style, inline.style);
                                        }
                                        if (inline.hasOwnProperty('className') && external.hasOwnProperty('className')) {
                                            res.className = external.className + ' ' + inline.className;
                                        }
                                        return res;
                                    }
                                    return this.template === 'text' ? _createElement('div', mergeProps_text({ 'className': 'cmTemplate_text' }, { dangerouslySetInnerHTML: { __html: typeof this.textHighlight === 'undefined' ? '' : this.textHighlight } })) : this.template === 'product' ? _createElement('div', { 'className': 'cmTemplate_product' }, _createElement('div', { 'className': 'image-block' }, _createElement('img', {
                                        'src': this.imageOrDefault(this.resizeImage(this.image || this.image1)),
                                        'alt': 'Image of ' + this.removeHTML(this.title),
                                        'onError': this.onImageError
                                    })), _createElement('div', { 'className': 'description-block' }, _createElement('div', mergeProps_product({ 'className': 'title' }, { dangerouslySetInnerHTML: { __html: typeof this.title === 'undefined' ? '' : this.title } })), _createElement('div', { 'className': 'price' }, '\n    ', this.price_varies ? `${ _translate(`price_from`) } ` : '', this.formatPrice(this.min_price || this.price), '\n  '))) : this.template === 'facetValue' ? _createElement('div', { 'className': 'cmTemplate_facetValue' }, this.imageUrl ? _createElement('div', {
                                        'className': 'image-block',
                                        'key': '35'
                                    }, _createElement('img', {
                                        'src': this.imageUrl,
                                        'alt': 'Image of ' + this.facetValue,
                                        'onError': onError1_facetValue.bind(this)
                                    })) : null, _createElement('div', { 'className': 'description-block' }, _createElement('div', mergeProps_facetValue({ 'className': 'title' }, { dangerouslySetInnerHTML: { __html: typeof this.value === 'undefined' ? '' : this.value } })), this.hitCount ? _createElement('span', {
                                        'className': 'hit-count',
                                        'key': '400'
                                    }, '(', this.hitCount, ')') : null)) : _createElement('div', { 'className': 'cmTemplate_Unknown' }, JSON.stringify(this));
                                }, { count: undefined })];
                        }
                        return _createElement('div', { 'className': 'section' + (this.sectionTitle ? ` ${ this.sectionTitle }` : '') }, _createElement('div', { 'className': 'section-title-div' }, _createElement('div', { 'className': 'item section-title' }, _createElement('b', {}, '\n          ', this.totalHits && _translate(`search_box_products_count`, {  totalHits : this. totalHits  }), ' ', _translate(`search_box_section_${ this.sectionTitle }`) || this.sectionTitle, '\n        '), '\n        ', this.vehicleString && _translate(`search_box_dropdown_vehicle`, {  vehicleString : this. vehicleString  }), '\n      ')), _createElement.apply(this, [
                            'div',
                            { 'className': 'cmRepeater_items' },
                            _map(this.items, repeatItems1.bind(this))
                        ]));
                    }, { count: undefined })];
            }
            return _createElement('div', { 'className': 'cm_autocomplete cm_dropdown' }, _createElement.apply(this, [
                'div',
                { 'className': 'cmRepeater_sections' },
                _map(this.sections, repeatSections1.bind(this))
            ]), this.browseAllButton ? [[this.browseAllButton(function () {
                        return _createElement('a', { 'className': 'item button-item cm_browseAllButton' }, _translate(`search_box_dropdown_browse`, { 
                            totalHits: this.
                            totalHits, 
                            query
                        : this.
                            query
                         }));
                    }, {
                        widgetName: 'undefined',
                        items: undefined
                    })]] : null, this.noResults ? _createElement('div', {
                'className': 'item cm_search-box_no-results',
                'key': '5262'
            }, '\n  ', _translate(`search_box_no_results`, {  query : this. query  }), '\n') : null);
        }, {
            widgetName: 'undefined',
            items: undefined
        })]);
}
        export const componentNames = ["cm:searchInput","cm:browseAllButton","cm:dropdown"]